var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReused = function SvgReused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 .016c1.078 0 2.016.89 2.016 1.968v12C17.016 15.11 16.078 16 15 16H6c-1.078 0-2.016-.89-2.016-2.016v-12C3.984.906 4.922.016 6 .016zm0 13.968v-12H6v12zM0 13h2.016v-2.016H0zm0-5.484v1.968h2.016V7.516zm6.984 10.5v1.968H9v-1.968zM0 16.516h2.016V14.5H0zm2.016 3.468v-1.968H0c0 1.078.89 1.968 2.016 1.968m3.468 0v-1.968H3.516v1.968zm5.016 0c1.078 0 2.016-.89 2.016-1.968H10.5zM2.016 4A2 2 0 0 0 0 6.016h2.016z"
  })));
};
export default SvgReused;